import { IconCheck, IconFileText, IconX } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import classNames from 'classnames';
import { formatDateLong } from 'ns_libs/formatter';
import './FileCard.scss';
import { ITemporaryUploadedFile } from 'views/ProFormaUpload/types';

interface IFileCardProps {
    file: Pick<ITemporaryUploadedFile, 'id' | 'name'> & { createdAt?: Date };
    isSelected?: boolean;
    onDelete?: () => void;
    onClick?: (isSelected: boolean) => void;
}

const FileCard = ({
    file, isSelected, onDelete, onClick,
}: IFileCardProps) => (
    <div
        role="button"
        tabIndex={0}
        onClick={() => onClick?.(!isSelected)}
        onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick?.(!isSelected);
            }
        }}
        className={classNames(
            'FileCard d-flex align-items-center p-2 rounded',
            { 'FileCard--selected': isSelected },
        )}
    >
        <NSIcon icon={IconFileText} className="FileCard__icon" size="lg" />
        <div className="FileCard__content">
            <div className="FileCard__filename" title={file.name}>{file.name}</div>
            <div className="FileCard__date">
                {formatDateLong(file.createdAt ?? new Date(), { month: 'long', day: 'numeric', year: 'numeric' })}
            </div>
        </div>
        {onDelete && (
            <NSIcon
                icon={IconX}
                className="cursor--pointer"
                onClick={e => {
                    e.stopPropagation();
                    onDelete();
                }}
            />
        )}
        {isSelected && (
            <NSIcon icon={IconCheck} size="lg" className="text-primary" />
        )}
    </div>
);

export default FileCard;
